import type { Maybe, Font, LayoutSettings } from "../types";

export function fontFamily(font: Maybe<Font>) {
  return font ? font.fontName : "var(--font-system)";
}

export function fontStyleHtml(font: Font) {
  return `
  <style>
    :root {
      --font-body: ${fontFamily(font)};
    }
  </style>`;
}

const lightTheme = {
  themeColor: "#333",
  backgroundColor: "var(--theme-elevation-1)",
  navBackgroundColor: "#000000"
};

type ThemeOptions = {
  pageBackgroundColor?: string;
};

export function themeStyleHtml(settings: LayoutSettings, data: ThemeOptions) {
  const baseTheme = lightTheme;
  const theme = {
    ...baseTheme,
    ...settings,
    ...settings.theme
  };

  const backgroundColor = data?.pageBackgroundColor || theme.backgroundColor;
  const navBackgroundColor = theme.navBackgroundColor || baseTheme.navBackgroundColor;
  const navSelectedBackgroundColor = theme.navSelectedBackgroundColor || theme.themeColor;
  const navIconColor = theme.navIconColor || "currentColor";
  const navSelectedIconColor = theme.navSelectedIconColor || "currentColor";

  return `
  <style>
    body {
      --theme-color: ${theme.themeColor};
      --theme-bg: ${backgroundColor};
      --theme-nav-bg: ${navBackgroundColor};
      --theme-nav-selected-bg: ${navSelectedBackgroundColor};
      --theme-nav-icon: ${navIconColor};
      --theme-nav-selected-icon: ${navSelectedIconColor};
    }
  </style>`;
}
